function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var r = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty,
    w = Object.prototype.propertyIsEnumerable;

var L = function L(o, C, t) {
  return C in o ? r(o, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[C] = t;
},
    e = function e(o, C) {
  for (var t in C || (C = {})) {
    l.call(C, t) && L(o, t, C[t]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        w.call(C, t) && L(o, t, C[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as i from "react";

function Z(o) {
  return i.createElement("svg", e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), i.createElement("path", {
    d: "M12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22ZM7.83073 18.9065L9.98439 16.7528C11.2669 17.2974 12.7315 17.298 14.0156 16.7528L16.1693 18.9065C13.6202 20.4516 10.3798 20.4516 7.83073 18.9065V18.9065ZM15.2258 12C15.2258 13.7787 13.7787 15.2258 12 15.2258C10.2213 15.2258 8.77419 13.7787 8.77419 12C8.77419 10.2213 10.2213 8.77419 12 8.77419C13.7787 8.77419 15.2258 10.2213 15.2258 12ZM18.9065 16.1693L16.7528 14.0156C17.2973 12.7331 17.298 11.2685 16.7528 9.98439L18.9065 7.83073C20.4516 10.3798 20.4516 13.6202 18.9065 16.1693ZM16.1692 5.09355L14.0156 7.24722C12.7331 6.70266 11.2685 6.70198 9.98439 7.24722L7.83073 5.09355C10.3798 3.54843 13.6202 3.54843 16.1692 5.09355ZM5.09355 7.83073L7.24722 9.98439C6.70262 11.2669 6.70198 12.7315 7.24722 14.0156L5.09355 16.1693C3.54843 13.6202 3.54843 10.3798 5.09355 7.83073V7.83073Z",
    fill: "black"
  }));
}

export { Z as ReactComponent };